import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-title-four',
  templateUrl: './title-four.component.html',
  styleUrls: ['./title-four.component.scss']
})
export class TitleFourComponent implements OnInit {
  @Input() title: string

  constructor() {}

  ngOnInit() {}
}
